exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content {\n  width: 135px; \n}\n.content.largeWidth {\n  width: 180px; \n  padding-right:20px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/render/grid-select-renderer.component.css
// module id = ../../../../../src/app/render/grid-select-renderer.component.css
// module chunks = main